// Layout.jsx

import React, { useState, useEffect } from "react";

import Sidebar from "./Sidebar";
import DealAssistant from "./DealAssistant";

const Layout = ({ children, activePage }) => {

  const [isCollapsed, setIsCollapsed] = useState(() => {

    const saved = localStorage.getItem("sidebarCollapsed");

    return saved ? JSON.parse(saved) : false;

  });

  useEffect(() => {

    localStorage.setItem("sidebarCollapsed", JSON.stringify(isCollapsed));

  }, [isCollapsed]);

  // widths must match Sidebar widths (w-64 -> 16rem = 256px). collapsed used 76.8px as in Sidebar.

  const expandedWidth = "16rem"; // w-64

  const collapsedWidth = "76.8px"; // w-[76.8px]

  return (
    <div className="min-h-screen">
      <Sidebar activePage={activePage} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

      <main

        style={{

          marginLeft: isCollapsed ? collapsedWidth : expandedWidth,

          transition: "margin-left 500ms ease",

        }}

        className="min-h-screen bg-gray-50"
      >

        {children}
      </main>
      <DealAssistant />
    </div>

  );

};

export default Layout;
